(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  // 商品名に「送料無料」を含む商品(お試しセット等)がカートに1つでも入っていれば
  // 注文全体が送料無料になる
  function isFreeShippingItem(item) {
    return typeof item.product_title === 'string' && item.product_title.indexOf('送料無料') !== -1;
  }

  function updateBars(totalCents, hasFreeItem) {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;

      var fill = bar.querySelector('[data-free-shipping-fill]');
      var text = bar.querySelector('[data-free-shipping-text]');

      if (hasFreeItem) {
        if (fill) fill.style.width = '100%';
        if (text) text.innerHTML = '<strong>このご注文は送料無料です</strong>';
        return;
      }

      var remaining = threshold - totalCents;
      var pct = Math.min(100, Math.floor((totalCents / threshold) * 100));

      if (fill) fill.style.width = pct + '%';

      if (text) {
        if (remaining <= 0) {
          text.innerHTML = '送料無料まで到達しました！';
        } else {
          text.innerHTML = 'あと<strong>' + formatMoney(remaining) + '</strong>で送料無料';
        }
      }
    });
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;

    var hasFreeItem = (cart.items || []).some(isFreeShippingItem);
    updateBars(cart.total_price, hasFreeItem);
  });
})();
